import { render } from "./Visualizar.vue?vue&type=template&id=bfe85daa"
const script = {}
script.render = render

export default script